<template>
  <validation-observer ref="form">
    <v-form v-if="form" @submit.prevent="save">
      <v-row>
        <v-col>
          <validation-provider
            rules="required|max:255|min:3"
            name="title"
            v-slot="{ errors }"
          >
            <v-text-field
              v-model="form.title"
              outlined
              required
              label="Title"
              :error-messages="errors"
            ></v-text-field>
          </validation-provider>

          <validation-provider
            rules="required|max:255|min:3"
            name="subtitle"
            v-slot="{ errors }"
          >
            <v-textarea
              v-model="form.subtitle"
              required
              outlined
              label="Subtitle"
              :error-messages="errors"
            >
            </v-textarea>
          </validation-provider>

          <validation-provider
            v-if="tag"
            rules="required|max:255"
            name="subtitle"
            v-slot="{ errors }"
          >
            <v-select
              :items="formattedCategories"
              v-model="form.resource_category_id"
              required
              outlined
              label="Category"
              :error-messages="errors"
            >
            </v-select>
          </validation-provider>
        </v-col>

        <v-col cols="12" md="4">
          <validation-provider
            v-slot="{ errors }"
            rules="required"
            name="cover"
          >
            <input hidden :value="resourceCover" />
            <v-img
              class="mb-4"
              v-if="resourceCover"
              :src="resourceCover"
              :lazy-src="resourceCover"
              size="100%"
            />
            <v-btn @click="addCover" color="primary">
              {{ resourceCover ? 'Change' : 'Add' }} cover image
            </v-btn>
            <div
              v-if="errors.length"
              class="v-messages theme--light error--text mt-3 pl-3"
            >
              <div class="v-messages__wrapper">
                <div class="v-messages__message">
                  {{ errors[0] }}
                </div>
              </div>
            </div>
          </validation-provider>
        </v-col>
      </v-row>

      <!-- Image cropper component -->
      <image-cropper
        v-model="showImageUpload"
        :aspect-ratio="11 / 16"
        @change="imageChanged"
      />
    </v-form>
  </validation-observer>
</template>

<script>
import Resource from '@/models/Resource'
import ImageCropper from '@/components/modals/ImageCropper'
import ResourceCategory from '@/models/ResourceCategory'
import * as ResourceType from '@/utils/consts/ResourceType'

export default {
  components: {
    ImageCropper
  },
  props: {
    value: {
      type: Resource,
      default() {
        return new Resource({
          title: '',
          subtitle: '',
          cover: null
        })
      }
    },
    tag: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: null,
      showImageUpload: false,
      cover: null,
      errors: [],
      categories: {
        data: []
      }
    }
  },
  mounted() {
    this.setForm(this.value)
    this.getCategories()
  },
  computed: {
    formattedCategories() {
      return this.categories.data.map(item => ({
        text: item.name,
        value: item.id
      }))
    },
    resourceCover() {
      if (this.cover) {
        return this.cover
      } else if (this.value.cover) {
        return this.value.cover.url
      }
      return null
    }
  },
  methods: {
    getCategories() {
      this.loadingCategories = true
      return ResourceCategory.where(
        'type',
        this.$route.name.includes('training.resources')
          ? ResourceType.TRAINING
          : ResourceType.LTG
      )
        .get()
        .then(response => {
          this.categories = response
        })
        .catch(() => {})
        .then(() => {
          this.loading = false
        })
    },
    setForm(resource) {
      this.form = resource
    },
    setErrors(errors) {
      this.$refs.form.setErrors(errors)
    },
    addCover() {
      this.showImageUpload = true
    },
    save() {
      this.$emit('save', {
        ...this.form,
        cover: this.cover ? this.form.cover : null
      })
    },
    imageChanged(image) {
      const reader = new FileReader()
      reader.readAsDataURL(image)
      reader.onload = e => {
        this.cover = reader.result
        this.form.cover = image
      }
    }
  },
  watch: {
    value(resource) {
      this.setForm(resource)
    },
    form(value) {
      this.$emit('input', value)
    }
  }
}
</script>
